<template lang="pug">
  div
    h2 Recuperar Senha

    .form-group(v-if="!sent")
      PTextField(v-model="email" label="email" placeholder="exemplo@gmail.com.br", v-focus name="email-forgot-pass")

      h5 Você receberá um link para recuperar a senha

      PButton(color="success" size="md" block @click="applyResetPassowd") Confirmar

    div(v-if="sent")
      br
      h4 Email de recuperação de senha enviado!

    PButton(color="info" @click="toLoginPage" size="sm") Voltar

    div(v-if="error")
      h4 {{ error }}

</template>

<script>
import { configureCongito, executeAuthCognitoRequest } from 'src/components/Cognito'

export default {
  data () {
    return {
      email: '',
      sent: false,
      error: null
    }
  },
  methods: {
    toLoginPage () {
      this.$router.push('/cognito/login')
    },
    async applyResetPassowd () {
      try {
        const { useCognito } = await executeAuthCognitoRequest(this.email)

        if (useCognito) {
          this.cognitoForgotPassword()
        } else {
          this.legacyForgotPassword()
        }
      } catch (e) {
        this.$swal({
          type: 'info',
          text: 'Não foi possível completar essa solicitação'
        })
      }
    },
    async cognitoForgotPassword () {
      try {
        const result = await this.$API.getAuthUserPool.save({email: this.email})

        const { userPoolWebClientId, userPoolId } = result.data.success
        configureCongito({userPoolId, userPoolWebClientId})

        try {
          await this.$API.authCognitoForgotPassword.save({email: this.email})
        } catch (e) {
          this.$swal({
            type: 'info',
            text: e.body.error || 'Não foi possível completar essa solicitação'
          })
          this.$store.dispatch('logout')
          return
        }
        this.sent = true
      } catch (e) {
        if (e.code === 'LimitExceededException') {
          this.$swal({
            type: 'warning',
            text: 'Várias solicitações de alteração de senha foram feitas para esse usuário. Tente novamente em alguns minutos.'
          })
        } else {
          this.$swal({
            type: 'error',
            text: 'Usuário não encontrado'
          })
        }
      }
    },
    async legacyForgotPassword () {
      try {
        const result = await this.$API.forgotPassword.get({email: this.email})
        this.$swal({text: result.body.msg, type: 'success'})
      } catch (e) {
        this.$swal({
          type: 'warning',
          text: 'Usuário não encontrado'
        })
      }
    }
  }
}
</script>

<style scoped>
.form-control {
  font-size: 18px;
  height: 50px;
}

.form-control, .control-label {
  width: 100%;
}
.confirm-forgot-password {
  width: 100%;
  height: 50px;
}

h5 {
  margin: 20px 0 20px 0;
}
</style>
